import { FC, useCallback, useState } from 'react';
import classNames from 'classnames';
import { Dropdown } from '../../assets/svgs';
import styles from './Collapse.module.scss';

interface Props {
  label: string,
  fluid?: boolean,
}

const Collapse: FC<Props> = ({ label, children, fluid = false }) => {
  const [isOpened, setIsOpened] = useState(true);

  const toggleCollapse = useCallback(() => {
    setIsOpened(prev => !prev);
  }, [setIsOpened])

  return (
    <div className={classNames(styles.container, { [styles.container_fluid]: fluid })}>
      <div className={classNames(styles.header, { [styles.header_not_fluid]: fluid })}>
        <span className={styles.label}>{label}</span>
        <Dropdown className={classNames(styles.icon, { [styles.icon_closed]: !isOpened })} onClick={toggleCollapse} />
      </div>
      <div className={classNames(styles.content, { [styles.content_opened]: isOpened, [styles.content_closed]: !isOpened })}>
        {children}
      </div>
    </div>
  )
}

export default Collapse;